// extracted by mini-css-extract-plugin
module.exports = {"main":"sk-CardBodyContent_main__5L1zn"};